export default __webpack_public_path__ + "static/media/chevron-up.cbc0de43.svg";